import React from 'react';
import { Body2 } from 'components/Typography';

interface ModalDetailsRowProps {
  label: string;
  value: React.ReactNode | string;
}

export const ModalDetailsRow = (props: ModalDetailsRowProps) => {
  const { label, value } = props;
  return (
    <div className='flex flex-row items-center justify-between'>
      <Body2
        as='div'
        className='self-start text-[0.875rem] leading-[1.25rem] text-white-400'
      >
        {label}
      </Body2>
      <Body2 as='div' className='text-[0.875rem] leading-[1.25rem] text-white'>
        {value}
      </Body2>
    </div>
  );
};
